module.exports = __webpack_public_path__ + "media/blueBackground.b5909dbb.png";